"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styleHelper = require("../styleHelper2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledPopup = _styledComponents.default.div.withConfig({
  displayName: "Popup__StyledPopup",
  componentId: "sc-1mtw0bv-0"
})(["position:absolute;z-index:99;top:100%;left:", ";right:", ";min-width:100%;border-radius:11px;margin-top:", ";background-color:", ";box-shadow:", ";border:1px solid ", ";", " ", " ", " ", " ", " ", " ", ""], props => props.anchor === 'right' ? 'auto' : '0px', props => props.anchor === 'right' ? '0px' : 'auto', props => props.theme.margin.small, props => props.theme.background.background100, props => props.theme.shadow.popup, props => props.theme.border.border600, props => props.anchor === 'center' ? 'left: 50%;' : '', props => props.anchor === 'center' ? 'transform: translateX(-50%);' : '', (0, _styleHelper.dimension)(), (0, _styleHelper.margin)(), (0, _styleHelper.position)(), (0, _styleHelper.padding)(), (0, _styleHelper.overflow)());
const Popup = /*#__PURE__*/(0, _react.forwardRef)(({
  show,
  children,
  width,
  ...props
}, ref) => {
  return show ? /*#__PURE__*/_react.default.createElement(StyledPopup, _extends({
    ref: ref,
    width: width
  }, props), children) : null;
});
Popup.propTypes = {
  show: _propTypes.default.bool,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  anchor: _propTypes.default.string,
  width: _propTypes.default.string
};
Popup.defaultProps = {
  show: false,
  className: null,
  children: null,
  anchor: null,
  width: 'auto'
};
const _default = Popup;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledPopup, "StyledPopup", "/Users/jake.clayton/frontend/ls-common-client/src/components/Popup.js");
  reactHotLoader.register(Popup, "Popup", "/Users/jake.clayton/frontend/ls-common-client/src/components/Popup.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/Popup.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();